import './App.css';
import React from "react";
import HabitsDashboard from './pages/homePage';

function App() {

  return (
    <div className="pt-12 flex justify-center items-center bg-gray-900">
      <HabitsDashboard />
    </div>
  );
}

export default App;
